(function () {
    String.prototype.includes = function (searchTerm) {
        return this.indexOf(searchTerm) >= 0
    } 
}());